import {
        humanizeNumber,
        handleClassRederer,
        calculate_legal_buyer, 
        calculate_legal_seller, 
        convertCurrency
} from "../market/functions"

import { calculate_entry_money } from "../market/single/calculates"

export const config = [
        {
                key: 'l18',
                value: 'نماد',
                sortValue: (row) => row.l18,
                renderer: (row) => <a target="_blank" rel="noreferrer" href={`https://www.tsetmc.com/instInfo/${row.tse_url}`}>{row.l18}</a>,
        },
        {
                key: 'pc',
                value: 'قیمت آخرین',
                sortValue: (row) => row.pc,
                renderer: (row) => humanizeNumber(row.pc),
        },
        {
                key: 'stock',
                value: 'نوع نماد',
                sortValue: (row) => row.stock,
                renderer: (row) => row.stock,
        },
        {
                key: 'tval',
                value: 'ارزش',
                sortValue: (row) => row.tval,
                renderer: (row) => humanizeNumber(convertCurrency(row.tval)),
        },
        {
                key: 'legal_buyer',
                value: 'سرانه خرید',
                sortValue: (row) => calculate_legal_buyer(row),
                renderer: (row) => humanizeNumber(convertCurrency(calculate_legal_buyer(row))),
        },
        {
                key: 'legal_seller',
                value: 'سرانه فروش',
                sortValue: (row) => calculate_legal_seller(row),
                renderer: (row) => humanizeNumber(convertCurrency(calculate_legal_seller(row))),
        },
        {
                key: 'power_buy',
                value: 'قدرت حقیقی',
                sortValue: (row) => row.power_buy,
                renderer: (row) => row.power_buy.toFixed(2),
                classes: (row) => row.power_buy >= 0 ? 'text-primary' : 'text-danger',
        },
        {
                key: 'entry_money',
                value: 'ورود پول',
                sortValue: (row) => calculate_entry_money(row),
                renderer: (row) => humanizeNumber(convertCurrency(calculate_entry_money(row))),
                classes: (row) => row.legal ? handleClassRederer(calculate_entry_money(row), 0) : '',
        }
]